import React from "react";


const Entitlement = () => {
  return <div>Entitlement</div>;
};

export default Entitlement;
